import { createContext, useContext } from 'react';
import { azureMapsProvider } from './azureMapsProvider';
import type { MapProvider } from './MapProvider';

const MapProviderContext = createContext<MapProvider>(azureMapsProvider);

/** Supplies a map provider to the tree; defaults to Azure Maps. Tests inject a fake. */
export const MapProviderContextProvider = MapProviderContext.Provider;

/**
 * Reads the active map provider.
 *
 * @returns The provider, Azure Maps unless one has been supplied above.
 */
export function useMapProvider(): MapProvider {
  return useContext(MapProviderContext);
}
